import React from 'react'

import { TextAreaContent } from '@models/Article'

import * as style from './style.module.sass'

type TextAreaProps = TextAreaContent & {
  index: number
}
const TextArea: React.FC<TextAreaProps> = ({ contents, index }) => (
  <div
    dangerouslySetInnerHTML={{ __html: contents }}
    className={style.textArea}
    data-index={index}
  />
)

export default TextArea
